import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import './directives/permission' // 导入权限指令

Vue.config.productionTip = false
Vue.use(ElementUI)

// 配置axios
axios.defaults.baseURL = '/api'
//.defaults.baseURL = 'http://8.138.170.50:8080/api'

// 请求拦截器 - 添加Token
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器 - 处理未登录
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$axios = axios

// 在Vue实例创建前，根据缓存的主题设置body背景色，避免闪烁
const cachedTheme = localStorage.getItem('admin_theme_config')
if (cachedTheme) {
  try {
    const theme = JSON.parse(cachedTheme)
    if (theme.adminThemeMode === 'dark') {
      document.body.style.backgroundColor = '#1a1a1a'
      document.documentElement.style.backgroundColor = '#1a1a1a'
      // 添加深色模式class到html元素，让全局样式立即生效
      document.documentElement.classList.add('admin-dark-mode')
    } else {
      document.body.style.backgroundColor = '#f0f2f5'
      document.documentElement.style.backgroundColor = '#f0f2f5'
      document.documentElement.classList.remove('admin-dark-mode')
    }
  } catch (e) {
    // 解析失败使用默认浅色
    document.body.style.backgroundColor = '#f0f2f5'
    document.documentElement.style.backgroundColor = '#f0f2f5'
    document.documentElement.classList.remove('admin-dark-mode')
  }
} else {
  document.body.style.backgroundColor = '#f0f2f5'
  document.documentElement.style.backgroundColor = '#f0f2f5'
  document.documentElement.classList.remove('admin-dark-mode')
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
